<template>
  <div class="dppl-accordion-panel">
    <div
      class="panel-header"
      :class="{ open }"
      @click="open = open ? null : itemId"
    >
      <slot name="panel-header" />
      <button
        type="button"
        :aria-label="itemLabel"
      >
        <v-icon
          class="chevron-icon"
          :class="{ expanded: open }"
          icon="$chevron-down"
          :size="20"
        />
      </button>
    </div>

    <div
      v-show="open"
      class="panel-content"
    >
      <slot name="panel-content" />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  itemId: {
    type: [Number, String],
    required: true,
  },
  modelValue: {
    type: [Number, String],
    default: '',
  },
  itemLabel: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['update:model-value']);

const open = computed({
  get: () => props.modelValue === props.itemId,
  set: (value) => { emit('update:model-value', value); },
});
</script>

<style lang="less" scoped>
.dppl-accordion-panel {
  width: 100%;
}

.panel-header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 8px;

  &.open {
    .chevron-icon :deep(path) {
      fill: @icon-darkest;
    }

    :slotted(.panel-title) {
      color: @text-darkest;
    }
  }

  &:hover {
    cursor: pointer;
    background-color: @bg-dark;
    border-radius: 8px;

    .chevron-icon :deep(path) {
      fill: @icon-darkest;
    }

    :slotted(.panel-title) {
      color: @text-darkest;
    }
  }

  .chevron-icon {
    transition: all 300ms;

    &.expanded {
      transform: rotate(180deg),
    }

    :deep(path) {
      fill: @icon-default;
    }
  }
}

.panel-content {
  width: 100%;
  padding: 6px 8px 8px 8px;
  border-bottom: 1px solid @stroke-default;
}
</style>
